import Axios from 'axios';
import { API_KEY, API_SERVER } from '../config/constant';
import AuthApi from './auth';

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

const axios = Axios.create({
  baseURL: `${API_SERVER}`,
  headers: { 'Content-Type': 'application/json' },
});

axios.interceptors.request.use(
  (config) => {
    if (sessionStorage.getItem('accesstoken')) {
      config.headers['Authorization'] = `Bearer ${sessionStorage.getItem('accesstoken') || ''
        }`;
    }
    config.headers['x-client-id'] = `${process.env.REACT_APP_CLIENT_ID}`;
    config.headers['X-Device-Id'] = '111111';
    config.headers['x-api-key'] = API_KEY;
    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error?.config;
    if (
      error.response.status === 401 &&
      !originalRequest._retry &&
      sessionStorage.getItem('accesstoken')
    ) {
      if (originalRequest.url === 'auth/refresh') {
        sessionStorage.removeItem('accesstoken');
        sessionStorage.removeItem('refreshtoken');
        window.location.href = '/signin';
        return Promise.reject(error);
      }

      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers['Authorization'] = 'Bearer ' + token;
            return axios(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      return new Promise(function (resolve, reject) {
        AuthApi.RefreshToken()
          .then((response) => {
            if (response.data.status_code === 200) {
              const { accesstoken, refreshtoken } = response.data.data;
              axios.defaults.headers.common[
                'Authorization'
              ] = `Bearer ${accesstoken}`;
              originalRequest.headers[
                'Authorization'
              ] = `Bearer ${accesstoken}`;
              sessionStorage.setItem('accesstoken', accesstoken);
              sessionStorage.setItem('refreshtoken', refreshtoken);
              processQueue(null, accesstoken);
              resolve(axios(originalRequest));
            } else {
              processQueue(response.data, null);
              reject(response.data);
            }
          })
          .catch((err) => {
            processQueue(err, null);
            reject(err);
          })
          .finally(() => {
            isRefreshing = false;
          });
      });
    } else if (
      error.response.status === 401 &&
      !sessionStorage.getItem('accesstoken')
    ) {
      sessionStorage.removeItem('accesstoken');
      sessionStorage.removeItem('refreshtoken');
      if (window.location.pathname !== '/signin') {
        window.location.href = '/signin';
      }
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default axios;
